import React, { PropsWithChildren, useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { parseSearch } from '../common/utl/EnvUtl';

export const affiliateCode: { val: string | undefined } = { val: undefined };

export function addAffiliateCode(url: string)
{
  if (typeof window !== `undefined`)
  {
    const q = parseSearch(window.location.search);
    const { ac } = q;
    if (ac)
    {
      affiliateCode.val = ac;
    }
  }

  if (typeof window !== `undefined`)
  {
    const urlObj = new URL(window.location.origin + url);
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.forEach((value, key) =>
    {
      if (key !== 'id')
      {
        urlObj.searchParams.set(key, value);
      }
    });

    if (affiliateCode.val)
    {
      urlObj.searchParams.set('ac', affiliateCode.val);
    }

    return urlObj.href.substring(window.location.origin.length);
  }

  return url;
}

export function AffiliateLink(props: PropsWithChildren<{ to: string, className?: string, activeClassName?: string }>)
{
  const [href, setHref] = useState(props.to);

  useEffect(() =>
  {
    setHref(addAffiliateCode(href));
  },
    [props.to]);

  return <Link to={href}>
    {props.children}
  </Link>;
}
